<template>
    <div class="products-tab">
        <div class="panel-header">
            <div class="left">
                <strong>제품 목록</strong>
                <p class="total">총 <span>{{ state.productLicenseList.length }}</span>개의 제품이 있습니다.</p>
            </div>
        </div>

        <div class="table-wrapper">
            <table class="table">
                <thead>
                    <tr>
                        <th>제품명</th>
                        <th style="width: 150px">할당 가능 수량</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-if="state.loading.products">
                        <td colspan="2" class="empty">제품 목록 불러오는 중...</td>
                    </tr>
                    <tr v-else-if="state.productLicenseList.length === 0">
                        <td colspan="2" class="empty">보유한 BOX 라이선스가 없습니다.</td>
                    </tr>
                    <tr v-for="product in state.productLicenseList" :key="product.productName" class="cell-link" @click="goLicenseDetail(product.productName)">
                        <td>{{ product.productName }}</td>
                        <td>{{ product.remainingQuantity }} / {{ product.totalQuantity }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
export default {
    name: 'userProductsTab',
    props: { selectedCrewId: { type: [Number, String], required: false } },
    data() {
        return {
            state: { loading: { products: false }, productLicenseList: [] },
        };
    },
    watch: {
        selectedCrewId: {
            immediate: true,
            handler() { this.fetchProductLicenses(); },
        },
    },
    methods: {
        goLicenseDetail(productName) {
            const crewId = this.selectedCrewId;
            if (!crewId || !productName) return;
            this.$router.push({ name: 'licenseDetail', params: { crewId, productName: encodeURIComponent(productName) } });
        },
        fetchProductLicenses() {
            if (!this.selectedCrewId) { this.state.productLicenseList = []; return; }
            this.state.loading.products = true;
            this.axiosCaller.get(
                this,
                this.APIs.LICENSE + '/getCrewLicenseInfo',
                { crewId: this.selectedCrewId },
                (result) => {
                    try {
                        const data = result?.data || {};
                        if (data.status === 'ok') this.state.productLicenseList = data.licenseList || [];
                        else this.state.productLicenseList = [];
                    } finally { this.state.loading.products = false; }
                }
            );
        },
    },
};
</script>

<style scoped>
</style>


